import { trackMetaAddToCart } from "../utils/metaPixel";

/**
 * Fires Meta AddToCart on every cart/addProduct (product page, cards, checkout recovery, etc.).
 */
export const metaPixelCartMiddleware = (storeApi) => (next) => (action) => {
  const result = next(action);
  if (action.type === "cart/addProduct") {
    const p = action.payload;
    const qty = Number(p.qty) || 0;
    const unit = Number(p.unitPrice) || 0;
    if (!p.productID) return result;
    const currency = storeApi.getState()?.store?.storeData?.currency || "INR";
    trackMetaAddToCart({
      contentIds: [String(p.productID)],
      contentName: p.productName,
      value: unit * qty,
      currency,
      numItems: qty,
    });
  }
  return result;
};
